export default __webpack_public_path__ + "static/christmas-9fef4b0bff8481b9a01b528f0b75e34e.svg";